module.exports = new __parcel__URL__("chili.27401d1a.svg").toString();